import './FilterMenuItem.styles.scss';

import { MultiSelect } from 'primereact/multiselect';
import React, { FC } from 'react';

import SortedMultiSelect from '../SortedMultiSelect/SortedMultiSelect';
import { FilterMenuItemProps } from './FilterMenuItem.types';

const FilterMenuItem: FC<FilterMenuItemProps> = ({ item }) => (
  <div className="FilterMenuItem-Component flex align-items-center">
    <label className="cursor-pointer">
      <i className={item.icon} />
      <span className="mx-2">{item.label}</span>
    </label>
    <div onClick={e => e.stopPropagation()}>
      {item.sorted ? (
        <SortedMultiSelect
          className="menu-item-selector"
          options={item.options}
          value={item.value}
          placeholder="Not selected"
          onChange={e => item.onChange(e.value)}
          filter
          maxSelectedLabels={1}
        />
      ) : (
        <MultiSelect
          className="menu-item-selector"
          options={item.options}
          value={item.value}
          placeholder="Not selected"
          onChange={e => item.onChange(e.value)}
          filter
          maxSelectedLabels={1}
        />
      )}
    </div>
  </div>
);

export default FilterMenuItem;
